module.exports = __webpack_public_path__ + "static/media/app.ce731da8.png";